import React from "react";

function AudioConverter() {
  return (
    <div className="text-center mt-5">
      <h2>Audio File Converter</h2>
      <p>Upload and convert your audio files here (Guest Access).</p>
    </div>
  );
}

export default AudioConverter;
